import React, {useState, useEffect} from 'react';

const TrendingTopics = ({updateSearch, keywords}) => {

  const renderSearch = (keyword) => {
    updateSearch(null, keyword);
  }

  return (
    <div className="trending-topics-section">
      <h2>Relevant Keywords</h2>
      <div className='trending-topics-container'>
        {keywords.map((keyword, idx) => {
          return (
            <a key={idx} onClick={() => renderSearch(keyword)} className='pill-container'>
              {keyword}
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default TrendingTopics;